import React from 'react';

function FirstAidIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M8 22V16H2V8H8V2H16V8H22V16H16V22H8Z"/>
    </svg>
  );
}

export default FirstAidIcon;

